import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BookmarkIcon = ({ color = '#8CA4C9', size = 18, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.92.58H2.08C.933.581.004 1.23 0 2.028V19.38c0 1.22 1.753 1.812 3.123.29L8 14.254l4.877 5.416c1.37 1.522 3.123.927 3.123-.29V2.03c-.004-.8-.933-1.447-2.08-1.45z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

BookmarkIcon.propTypes = propTypes;

export default BookmarkIcon;
